import { identity, keyBy, mapValues, values } from "lodash";

export const TUTORIALS = {};
// export const TUTORIALS = {
//   INTRO: "intro",
//   EDIT_LAYOUT: "edit-layout",
//   RESIZABLE: "resizable",
// };
// export const TUTORIALS_LIST = values(TUTORIALS);

export const DEFAULT_TUTORIAL_STATUSES = {};
// export const DEFAULT_TUTORIAL_STATUSES = {
//   ...mapValues(keyBy(TUTORIALS_LIST, identity), () => 0),
// };

// export const TUTORIAL_PAGES = {
//   GROUP: "GROUP",
//   CHARACTER: "CHARACTER",
//   SHIP: "SHIP",
//   GM: "GM",
//   COMPENDIUM: "COMPENDIUM",
// };

export const TUTORIAL_STEP_TYPES = {
  MODAL: "MODAL",
  TOOLTIP: "TOOLTIP",
};

export const ADDITIONAL_TUTORIAL_DATA_KEYS = {
  EDIT_LAYOUT_MODAL_OPEN: "editLayoutModalOpen",
  RESIZABLE_ASPECT_PRESENT: "resizableAspectPresent",
};
